export default {"src":"/_next/static/media/fr.1bdaf7b5.svg","height":341,"width":512,"blurWidth":0,"blurHeight":0};